import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { formatMoney, getInlineLoader } from "../Helpers";
import { MdAdd, MdSearch } from "react-icons/md";
import OneSale from "../ones/OneSale";

export default function View(props) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [recsList, setRecsList] = useState(null);
  const [filter, setFilter] = useState("");
  const [category, setCategory] = useState("all");

  async function init() {
    setReady(false);
    await appContext.getAllSales();
    setReady(true);
  }

  function processRecs() {
    let _list = appContext.allSales || [];

    // Apply Category Filter
    if (category === "loan") {
      _list = _list.filter((i) => i.saleType === "loan");
    } else if (category === "cash") {
      _list = _list.filter((i) => i.saleType === "cash");
    } else if (category === "active") {
      _list = _list.filter((i) => i.status === "published" || i.status === "active");
    } else if (category === "unpublished") {
      _list = _list.filter((i) => i.status === "unpublished");
    }

    // Apply Search Filter
    if (filter.trim()) {
      const search = filter.toLowerCase();
      _list = _list.filter((item) => 
        `${item.model || ""} ${item.fullname || ""}`.toLowerCase().includes(search)
      );
    }

    setRecsList(_list);
  }

  useEffect(() => { init(); }, []);
  useEffect(() => { processRecs(); }, [filter, category, appContext.allSales]);

  if (!ready) return <div className="container mSupportLoading">{getInlineLoader()}</div>;

  const loanSales = (appContext.allSales || []).filter((i) => i.saleType === "loan");
  const salesValue = (appContext.allSales || []).reduce((sum, i) => sum + Number(i.price || 0), 0);

  return (
    <div className="container">
      <div className="app-page">
        <div className="app-page-hero app-page-hero-split">
          <div>
            <h6 className="main-section-title">Sales</h6>
            <p className="app-page-subtitle">Track motorcycle purchases and financing operations.</p>
          </div>
          <div className="d-flex flex-column gap-2">
            <button className="btn btn-primary btn-rounded app-cta-btn" onClick={() => appContext.navTo({ item: "view", subItem: "create-sale" })}>
              <MdAdd size={18} /> Add Sale
            </button>
            <button className="btn btn-danger btn-rounded app-cta-btn" onClick={() => appContext.navTo({ item: "view", subItem: "create-resale" })}>
              <MdAdd size={18} /> Resale
            </button>
          </div>
        </div>

        <div className="row">
          <div className="col-md-4"><div className="summary-mini-card"><span>Total sales</span><strong>{appContext.allSales?.length || 0}</strong></div></div>
          <div className="col-md-4"><div className="summary-mini-card"><span>Loan sales</span><strong>{loanSales.length}</strong></div></div>
          <div className="col-md-4"><div className="summary-mini-card"><span>Portfolio value</span><strong>{formatMoney(salesValue)}</strong></div></div>
        </div>

        <div className="list-shell">
          <div className="list-toolbar">
            <div className="modern-search">
              <MdSearch size={20} />
              <input className="form-control" onChange={(e) => setFilter(e.target.value)} placeholder="Search sales..." />
            </div>
            <select className="form-control modern-filter" value={category} onChange={(e) => setCategory(e.target.value)}>
              <option value="all">All records</option>
              <option value="loan">Loan Sales</option>
              <option value="cash">Cash Sales</option>
            </select>
          </div>

          <div className="entity-list">
            {recsList?.length > 0 ? (
              recsList.map((item, i) => <OneSale key={i} data={item} />)
            ) : (
              <div className="empty-state-lite">No records found.</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}